<app-feature-hero
    title="Infraon Assets for <br /> IT Services"
    description="Leverage Advanced IT Asset Management to Build and Maintain a Reliable Infrastructure Ecosystem"
    image="/assets/img/feature-pages/infraon-assets/it-services-solution/hardware-hero-img-01-01.svg"
    imageAlt="Hardware Asset Management Hero Image"
></app-feature-hero>

<section class="container section-spacing">
    <div class="row align-items-center section-spacing pt-0">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h2 class="section-title">
                    What is ITAM for IT Services Companies?
                </h2>
                <p class="section-paragraph">
                    IT Asset Management (ITAM) can be a moment of truth for IT
                    services companies. It plays a crucial role in managing and
                    optimizing IT resources, involving real-time tracking and analysis
                    of IT assets, from acquisition through to retirement.
                </p>
                <p class="section-paragraph">
                    So, it drives efficient use of resources while enabling compliance
                    with industry standards. This approach also minimizes costs and
                    maximizes utilization, particularly in environments with complex
                    IT infrastructures.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img src="/assets/img/feature-pages/infraon-assets/it-services-solution/it-solutions-assets-feature-1.webp"
                class="w-100" alt="hardware asset management" />
        </div>
    </div>
    <div class="row align-items-center section-spacing pb-0 reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img src="/assets/img/feature-pages/infraon-assets/it-services-solution/it-solutions-assets-feature-2.webp"
                class="w-90" alt="hardware asset management" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h2 class="section-title">What does ITAM do for IT Services?</h2>
                <p class="section-paragraph">
                    Infraon ITAM is a comprehensive IT asset management tool designed
                    for IT services companies. It streamlines managing both digital
                    and physical IT assets, enhancing operational efficiency.
                </p>
                <p class="section-paragraph">
                    This system is integral for optimizing asset usage, lifecycle
                    management, and cost reduction. It ensures proper tracking and
                    maintenance of IT assets, contributing significantly to
                    operational resilience.
                </p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">
        Key Benefits of ITAM for IT Services
    </h2>

    <div class="row mx-0 align-items-center section-spacing pt-0">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Real-Time IT Asset Optimization</h3>
                <p class="section-paragraph">
                    Infraon ITAM ensures continuous optimization of IT asset
                    management, enabling real-time updates and adjustments.
                </p>
                <p class="section-paragraph">
                    It integrates the management of purchase, deployment, maintenance,
                    and disposal into a single, streamlined process. This unified
                    approach negates the need for relying on multiple software
                    systems.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-assets/it-services-solution/qr-code-feature-img-2-01.png"
                alt="Device discovery charts" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-assets/it-services-solution/qr-code-feature-img-3-01.png"
                alt="maintenance Cost" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Optimized Cost Management</h3>
                <p class="section-paragraph">
                    Infraon ITAM lowers the overall costs associated with hardware and
                    software asset management.
                </p>
                <p class="section-paragraph">
                    It achieves this without the necessity of employing expensive,
                    certified professionals, thereby offering a cost-effective asset
                    management solution. This results in huge savings for IT services
                    companies.
                </p>
            </div>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Vendor Performance Management</h3>
                <p class="section-paragraph">
                    With Infraon ITAM, it becomes easy to accurately monitor the
                    performance of IT asset management software vendors.
                </p>
                <p class="section-paragraph">
                    This feature is crucial for avoiding contractual oversights and
                    hidden expenses, ensuring financial transparency and
                    accountability. It provides a safeguard against any potential
                    financial discrepancies or shadow expenses.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-assets/it-services-solution/barcode-feature-img-4-01.webp"
                alt="Infraon Assets Dashboard" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-assets/it-services-solution/itsm-workflow-management-feature-5-01.png"
                alt="Head office - primary" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Enhanced Security and Compliance</h3>
                <p class="section-paragraph">
                    Infraon ITAM offers comprehensive tracking of security and
                    compliance risks. Through actionable insights and intelligent
                    alerts, it allows for proactive risk mitigation strategies.
                </p>
                <p class="section-paragraph">
                    This level of security and compliance management is important for
                    maintaining the integrity and safety of IT assets.
                </p>
            </div>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Increased Operational Agility</h3>
                <p class="section-paragraph">
                    Infraon ITAM enhances operational agility by automating and
                    simplifying asset management processes. This agility allows IT
                    services to quickly adapt to changing business needs and
                    technological advancements.
                </p>
                <p class="section-paragraph">
                    It also makes sure that asset management is not a bottleneck but a
                    driver of operational flexibility.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="features-images"
                src="/assets/img/feature-pages/infraon-assets/it-services-solution/itsm-workflow-management-feature-2-01.png"
                alt="Config Sliders" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing pb-0 reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy" class="w-90 features-images"
                src="/assets/img/feature-pages/infraon-assets/it-services-solution/it-solutions-assets-feature-3-01.webp"
                class="w-80" alt="Reporting" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Data-Driven Decision Making</h3>
                <p class="section-paragraph">
                    Infraon ITAM empowers IT services with data-driven insights for
                    better decision-making.
                </p>
                <p class="section-paragraph">
                    By providing detailed analytics and reports on asset performance
                    and utilization, it enables informed strategic planning. This
                    approach leads to smarter investments and optimizations in the IT
                    asset portfolio.
                </p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm depreciation-calculator d-flex align-items-center justify-content-between primary-bg">
        <div>
            <h2 data-aos="fade-up" data-aos-delay="100" class="section-title text-start text-white">
                Introducing Our Asset <br />
                Depreciation Calculator 📉
            </h2>
            <p data-aos="fade-up" data-aos-delay="300" class="section-paragraph text-start text-white">
                Optimize your financial planning with our latest tool! <br />
                Easily calculate asset depreciation and make informed <br />
                decisions for your business.
            </p>
            <a routerLink="/free-tools/asset-depreciation-calculator/" class="text-white">
                <span>Click here to explore</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                    <path
                        d="M17.2968 5.51799L12.4968 0.717991C11.562 -0.218009 10.038 -0.218009 9.10316 0.717991C8.64956 1.17039 8.39996 1.77399 8.39996 2.41479C8.39996 3.05559 8.64956 3.65919 9.10316 4.11159L12.2064 7.21479L9.10316 10.318C8.64956 10.7716 8.39996 11.374 8.39996 12.0148C8.39996 12.6556 8.64956 13.258 9.10316 13.7116C9.55676 14.1652 10.1592 14.4148 10.8 14.4148C11.4408 14.4148 12.0432 14.1652 12.4968 13.7116L17.2968 8.91159C17.7504 8.45919 18 7.85559 18 7.21479C18 6.57399 17.7504 5.97039 17.2968 5.51799ZM16.4484 8.06319L11.6484 12.8632C11.1936 13.3168 10.4064 13.3168 9.95156 12.8632C9.48356 12.3952 9.48356 11.6344 9.95156 11.1664L13.9032 7.21479L9.95156 3.26319C9.72476 3.03639 9.59996 2.73519 9.59996 2.41479C9.59996 2.09439 9.72476 1.79319 9.95156 1.56639C10.1856 1.33239 10.4928 1.21479 10.8 1.21479C11.1072 1.21479 11.4144 1.33239 11.6484 1.56519L16.4484 6.36519C16.6752 6.59319 16.8 6.89439 16.8 7.21479C16.8 7.53519 16.6752 7.83639 16.4484 8.06319Z"
                        fill="white" />
                    <path
                        d="M8.8968 5.51799L4.0968 0.717991C3.162 -0.218009 1.638 -0.218009 0.7032 0.717991C0.2496 1.17039 0 1.77399 0 2.41479C0 3.05559 0.2496 3.65919 0.7032 4.11159L3.8064 7.21479L0.7032 10.318C0.2496 10.7716 0 11.374 0 12.0148C0 12.6556 0.2496 13.258 0.7032 13.7116C1.1568 14.1652 1.7592 14.4148 2.4 14.4148C3.0408 14.4148 3.6432 14.1652 4.0968 13.7116L8.8968 8.91159C9.3504 8.45919 9.6 7.85559 9.6 7.21479C9.6 6.57399 9.3504 5.97039 8.8968 5.51799ZM8.0484 8.06319L3.2484 12.8632C2.7936 13.3168 2.0064 13.3168 1.5516 12.8632C1.0836 12.3952 1.0836 11.6344 1.5516 11.1664L5.5032 7.21479L1.5516 3.26319C1.3248 3.03639 1.2 2.73519 1.2 2.41479C1.2 2.09439 1.3248 1.79319 1.5516 1.56639C1.7856 1.33239 2.0928 1.21479 2.4 1.21479C2.7072 1.21479 3.0144 1.33239 3.2484 1.56519L8.0484 6.36519C8.2752 6.59319 8.4 6.89439 8.4 7.21479C8.4 7.53519 8.2752 7.83639 8.0484 8.06319Z"
                        fill="white" />
                </svg>
            </a>
        </div>
    </div>
</section>

<section class="container section-spacing features">
    <h2 class="section-title p-b-60 mb-0">
        Using Infraon ITAM for IT Services
    </h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="26px"
                    height="22.8px" viewBox="0 0 26 22.8" style="enable-background: new 0 0 26 22.8"
                    xml:space="preserve">
                    <g>
                        <path fill="#A8C0F1"
                            d="M0,14.6c0-1.3,1.1-2.4,2.4-2.4h6.5c1.3,0,2.4,1.1,2.4,2.4v5.7c0,1.4-1.1,2.4-2.4,2.4H2.4   c-1.4,0-2.4-1.1-2.4-2.4V14.6z M15.4,0h8.1C24.9,0,26,1.1,26,2.4v1.6c0,1.4-1.1,2.4-2.4,2.4h-8.1c-1.4,0-2.4-1.1-2.4-2.4V2.4   C13,1.1,14.1,0,15.4,0z M13,10.6c0-1.3,1.1-2.4,2.4-2.4h8.1c1.3,0,2.4,1.1,2.4,2.4v1.6c0,1.4-1.1,2.4-2.4,2.4h-8.1   c-1.4,0-2.4-1.1-2.4-2.4V10.6z M15.4,16.2h8.1c1.3,0,2.4,1.1,2.4,2.4v1.6c0,1.4-1.1,2.4-2.4,2.4h-8.1c-1.4,0-2.4-1.1-2.4-2.4v-1.6   C13,17.4,14.1,16.2,15.4,16.2z" />
                        <path fill="#1A5AD9"
                            d="M0,2.6c0-1.3,1.1-2.4,2.4-2.4h6.5c1.3,0,2.4,1.1,2.4,2.4v5.7c0,1.4-1.1,2.4-2.4,2.4H2.4C1.1,10.7,0,9.6,0,8.2   V2.6z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">
                    IT Asset Lifecycle Management
                </h3>
                <p class="section-paragraph text-start">
                    Infraon ITAM manages IT asset lifecycles, aligning IT strategies
                    with business objectives. It handles every phase, from planning
                    and acquisition to maintenance and disposal, so that IT assets
                    contribute to achieving business goals.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="28.5px"
                    height="28.5px" viewBox="0 0 28.5 28.5" style="enable-background: new 0 0 28.5 28.5"
                    xml:space="preserve">
                    <g>
                        <path fill="#084CD4"
                            d="M12.2,7.9c0-4.3,3.5-7.9,7.9-7.9c1,0,2,0.2,2.9,0.6l-4.6,4.6v4.4h4.4L27.4,5C27.8,5.9,28,6.8,28,7.9   c0,3.4-2.1,6.2-5.1,7.4l-2.5-2.5l-1.2-1.3L18,12.8l-0.4,0.4L12.2,7.9L12.2,7.9z M0,22.8l9.2-9.2l4,4L12.7,18l-1.3,1.2l1.3,1.3   L5.2,28L0,22.8z M7.5,22.3l-1.8-1.8l-1.9,1.8l1.9,1.9L7.5,22.3z" />
                        <path fill="#A8C1F1"
                            d="M16.2,18.1L9.1,11H5.8L0.5,4L4,0.5l7,5.2v3.4l7.1,7l1.7-1.7l8.8,8.8l-5.2,5.2l-8.8-8.8L16.2,18.1z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">
                    IT Hardware Asset Management
                </h3>
                <p class="section-paragraph text-start">
                    This feature of Infraon ITAM tracks all physical IT components,
                    such as laptops and servers. By monitoring these assets, it helps
                    in lowering the total cost of ownership and making sure
                    IT-critical assets are smoothly functioning.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="35px"
                    height="28px" viewBox="0 0 35 28" style="enable-background: new 0 0 35 28" xml:space="preserve">
                    <g>
                        <path fill="#A8C1F1" d="M3.5,12.8v10.5H0V12.8H3.5z M35,12.8v10.5h-3.5V12.8H35z" />
                        <path fill="#084CD4"
                            d="M19,0v1.8v3.5h10.5V28H5V5.2h10.5V1.8V0H19z M14.2,14c0-1.2-1-2.2-2.2-2.2c-1.3,0-2.2,1-2.2,2.2   c0,1.3,0.9,2.2,2.2,2.2C13.2,16.2,14.2,15.3,14.2,14z M22.5,16.2c1.2,0,2.2-0.9,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.3,0-2.2,1-2.2,2.2   C20.3,15.3,21.2,16.2,22.5,16.2z" />
                        <path fill="#A8C0F1"
                            d="M11,21h12c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H11c-0.6,0-1-0.4-1-1l0,0C10,21.4,10.4,21,11,21z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">Software Asset Management</h3>
                <p class="section-paragraph text-start">
                    Infraon ITAM centralizes the management of IT software components.
                    It streamlines purchase, deployment, maintenance, and disposal,
                    reducing risks and operational costs. This advanced approach to
                    software management also boosts security.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="28px"
                    height="26.2px" viewBox="0 0 28 26.2" style="enable-background: new 0 0 28 26.2"
                    xml:space="preserve">
                    <style type="text/css">
                        .st1 {
                            fill: #a8c1f1;
                        }

                        .st2 {
                            fill: #ac67f0;
                        }

                        .st3 {
                            fill: #1a5ad9;
                        }

                        .st4 {
                            fill: #ab67f0;
                        }
                    </style>
                    <g>
                        <path fill="#084CD4"
                            d="M0,21.9c0-0.7,0.5-1.3,1.3-1.3h3.2c0.5-1.8,2.2-3.1,4.2-3.1c1.9,0,3.6,1.3,4.2,3.1h13.8c0.7,0,1.3,0.6,1.3,1.3   c0,0.8-0.6,1.3-1.3,1.3H12.9c-0.5,1.8-2.2,3.1-4.2,3.1c-2,0-3.7-1.3-4.2-3.1H1.3C0.5,23.2,0,22.6,0,21.9z M5.5,21.6   c0-0.9,4.2-0.3,3.2-0.3c-1,0,2.6-0.4,2.6,0.6c0,1-3.6,0-2.6,0C9.7,21.9,5.5,22.6,5.5,21.6z M26.7,3.1c0.7,0,1.3,0.6,1.3,1.3   c0,0.8-0.6,1.3-1.3,1.3h-12c-0.5,1.8-2.2,3.1-4.2,3.1c-2,0-3.7-1.3-4.2-3.1h-5C0.5,5.7,0,5.1,0,4.4c0-0.7,0.5-1.3,1.3-1.3h5   C6.8,1.3,8.5,0,10.5,0c1.9,0,3.6,1.3,4.2,3.1H26.7z M12.7,4.4c0,1-3.3,0-2.3,0c0.9,0,1.9,1,1.9,0c0-0.9-0.9,0-1.9,0   C9.4,4.4,12.7,3.4,12.7,4.4z" />
                        <path class="st2"
                            d="M19.2,8.6c1.9,0,3.6,1.3,4.2,3.1h3.3c0.7,0,1.3,0.6,1.3,1.3c0,0.8-0.6,1.3-1.3,1.3h-3.3   c-0.5,1.8-2.2,3.1-4.2,3.1c-2,0-3.7-1.3-4.2-3.1H1.3C0.5,14.3,0,13.8,0,13c0-0.7,0.5-1.3,1.3-1.3H15C15.6,9.9,17.3,8.6,19.2,8.6z    M21,12.6c0-0.9,1.4,0,0.5,0c-1,0,1.5-0.4,1.5,0.5c0,1-6.5-0.5-5.5-0.5C18.4,12.6,21,13.6,21,12.6z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">Access Control</h3>
                <p class="section-paragraph text-start">
                    Infraon ITAM's access control feature ensures secure management of
                    IT assets. It implements strict authentication and authorization
                    protocols, maintaining comprehensive security and compliance
                    standards.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="34px"
                    height="30px" viewBox="0 0 34 30" style="enable-background: new 0 0 34 30" xml:space="preserve">
                    <g>
                        <rect x="12" y="6" fill="#A8C1F1" width="10" height="24" />
                        <path fill="#084CD4"
                            d="M17,0c0.9,0,1.8,0.5,2.3,1.3L33.7,26c0.5,0.9,0.5,1.9,0,2.7c-0.5,0.9-1.3,1.3-2.3,1.3H2.7   c-1,0-1.9-0.5-2.3-1.3c-0.5-0.8-0.5-1.8,0-2.7L14.7,1.3C15.2,0.5,16,0,17,0z M17,8.6c-0.9,0-1.6,0.7-1.6,1.6v7.5   c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6v-7.5C18.6,9.3,17.9,8.6,17,8.6z M19.2,23.6c0-1.1-1-2.1-2.1-2.1   c-1.2,0-2.1,1-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1C18.2,25.7,19.2,24.8,19.2,23.6z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">Low Stock Alerts</h3>
                <p class="section-paragraph text-start">
                    This feature of Infraon ITAM promptly notifies managers of low
                    asset stock, enabling proactive replenishment. It helps avoid
                    operational delays caused by asset shortages, maintaining
                    continuous business operations.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="31.5px"
                    height="21px" viewBox="0 0 31.5 21" style="enable-background: new 0 0 31.5 21" xml:space="preserve">
                    <g>
                        <path fill="#084CD4"
                            d="M31.5,3.5v4.4c-1.5,0-2.6,1.2-2.6,2.6c0,1.5,1.1,2.6,2.6,2.6v4.4c0,2-1.6,3.5-3.5,3.5H3.5   c-2,0-3.5-1.5-3.5-3.5v-4.4c1.4,0,2.6-1.1,2.6-2.6c0-1.4-1.2-2.6-2.6-2.6V3.5C0,1.6,1.5,0,3.5,0H28C29.9,0,31.5,1.6,31.5,3.5z" />
                        <path fill="#A8C1F1"
                            d="M6.8,6.8C6.8,5.8,7.5,5,8.5,5h14c0.9,0,1.8,0.8,1.8,1.8v7c0,1-0.8,1.8-1.8,1.8h-14c-1,0-1.8-0.8-1.8-1.8V6.8z    M21.6,7.6H9.4v5.2h12.2V7.6z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">Integrated Ticketing</h3>
                <p class="section-paragraph text-start">
                    Infraon ITAM includes an inbuilt ticketing system, offering
                    multi-channel support and self-service through chatbots. This
                    integration simplifies IT ticket management, enhancing user
                    experience and operational efficiency. It supports a more
                    responsive and user-friendly IT service environment.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="30px"
                    height="27px" viewBox="0 0 30 27" style="enable-background: new 0 0 30 27" xml:space="preserve">
                    <style type="text/css">
                        .st0 {
                            fill: #084cd4;
                        }

                        .st1 {
                            fill: #a8c1f1;
                        }

                        .st2 {
                            fill: #ac67f0;
                        }

                        .st3 {
                            fill: #1a5ad9;
                        }

                        .st4 {
                            fill: #ab67f0;
                        }
                    </style>
                    <g>
                        <path class="st2"
                            d="M10.8,13.5c1.4,0,2.5,1.2,2.5,2.5v8.4c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5V16   C8.3,14.7,9.4,13.5,10.8,13.5z M2.5,20.2c1.4,0,2.5,1.2,2.5,2.5v1.7C5,25.9,3.9,27,2.5,27C1.1,27,0,25.9,0,24.5v-1.7   C0,21.4,1.1,20.2,2.5,20.2z" />
                        <path class="st3"
                            d="M30,2.5C30,1.2,28.9,0,27.5,0C26.1,0,25,1.2,25,2.5v21.9c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5V2.5z" />
                        <path class="st3"
                            d="M19.2,6.8c-1.4,0-2.5,1.2-2.5,2.5v15.2c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5V9.3   C21.7,7.9,20.5,6.8,19.2,6.8z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">Network Discovery</h3>
                <p class="section-paragraph text-start">
                    Infraon ITAM helps track assets connected to the company network.
                    It comes with license management capabilities to eliminate
                    redundant costs, as well.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="22.8px"
                    height="26.2px" viewBox="0 0 22.8 26.2" style="enable-background: new 0 0 22.8 26.2"
                    xml:space="preserve">
                    <style type="text/css">
                        .st1 {
                            fill: #a8c1f1;
                        }

                        .st2 {
                            fill: #ac67f0;
                        }

                        .st3 {
                            fill: #1a5ad9;
                        }

                        .st4 {
                            fill: #ab67f0;
                        }
                    </style>
                    <g>
                        <path class="st4"
                            d="M10.6,18.5l-1-1.6c-0.3-0.6,0.1-1.3,0.7-1.3h1h1c0.7,0,1,0.7,0.7,1.3l-1,1.6l1.7,6.3l2-8.2c3.9,0.6,7,4,7,8.1   c0,0.9-0.7,1.5-1.6,1.5h-7.7H9.2H1.5c-0.9,0-1.5-0.7-1.5-1.5c0-4.1,3-7.5,6.9-8.1l2,8.2L10.6,18.5z" />
                        <path fill="#084CD4"
                            d="M10.9,0c3.6,0,6.5,2.9,6.5,6.5c0,3.6-2.9,6.5-6.5,6.5c-3.6,0-6.5-2.9-6.5-6.5C4.4,2.9,7.3,0,10.9,0z" />
                    </g>
                </svg>
                <h3 class="section-title text-start">Agent-Based Discovery</h3>
                <p class="section-paragraph text-start">
                    Infraon ITAM provides in-depth insights at the agent level,
                    including usage data. This is crucial for maintaining network
                    quality and avoiding availability issues.
                </p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation
                    (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our
                    customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO
                credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a routerLink="/it-asset-management/prices/assets-pricing" class="secondary-button bg-white">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/it-assets-management-solutions">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/it-services-solution/itam-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="IT Asset Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">IT Asset Management</p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-assets-management-solutions">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/it-services-solution/sam-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="Software Asset Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">
                            Software Asset Management
                        </p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a routerLink="/itsm-tool">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/it-services-solution/itsm-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="IT Service Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">IT Service Management</p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>